
































import Vue from "vue";
import AdminService from "@/services/adminService";

export default Vue.extend({
  name: "IntegrationNumber",

  data() {
    return {
      report: "",
      show: false,
      updating: false
    };
  },
  async created() {
    const jwt = window.localStorage.getItem("jwt");
    if (jwt) {
      const adminService = new AdminService(jwt);
      const response = await adminService.getClockifyReport();
      if (response && response.status == 200) {
        this.report = response.data;
        this.show = true;
      }
    }
  },
  methods: {
    async submit(e) {
      this.updating = true;
      e.preventDefault();
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const adminService = new AdminService(jwt);
        const formData = new FormData();
        formData.append("report", this.report.trim());
        const response = await adminService.updateClockifyReport(formData);
        if (response && response.status == 200) {
          if (response.data) {
            this.updating = false;
            alert("Update Successfully");
            await this.$router.push("/admin-panel");
          }
        }
      }
    },
    async cancel() {
      await this.$router.push("/admin-panel");
    }
  }
});
